import React from 'react';
import { Container } from 'react-bootstrap';
import '../../../src/styles/Container.css';
import '../../../src/styles/Buttons.css';

interface PageContainerProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
}

const PageContainer = ({ children, title, subtitle }: PageContainerProps) => {
  return (
    <>
      <Container
        fluid
        className="mt-2 d-flex flex-column align-items-center base-container"
      >
        <h1 className="text-center mb-2 page-container-title">{title}</h1>
        {subtitle && <p className="text-center fs-4 mb-1">{subtitle}</p>}
        {children}
      </Container>
    </>
  );
};

export default PageContainer;
